// extracted by mini-css-extract-plugin
module.exports = {"root":"_2nrED","bg":"_3-EKT","ribbon":"nLJ1t","frRibbon":"_2QTJi","flRibbon":"_3zheb"};